import { usePermissions } from '@/features/auth';
import { canChangeAutomationSettings } from './can-change-automation-settings';

/** Whether the viewer may change the automation settings, not only read them. */
export function useCanChangeAutomationSettings(): boolean {
  const { hasPermission } = usePermissions();
  return canChangeAutomationSettings(hasPermission);
}
